import React from "react";
import './Body9.css';
import {Link} from "react-router-dom"
import picture218 from './source/picture218.png'
import picture216 from './source/picture216.png'
import picture217 from './source/picture217.png'


function Body9() {

  return (
    <div className="body9">
      <div className="body9-box1">
        <div className="body9-box2">
          <div className="body9-box3">Hluk</div>
          <div className="body9-box5"><div className="body9-box4"></div></div>
          <div className="body9-box6">
          <img className="body9-box6-picture" src={picture218} alt="picture1"/>
          <img className="body9-box6-picture" src={picture217} alt="picture1"/>
          <img className="body9-box6-picture2" src={picture216} alt="picture1"/>          
          </div>
          <div className="body9-box9"><div className="body9-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body9;
